module.exports = __webpack_public_path__ + "static/media/hacked-kerx-webfont.3258f6c7.woff2";